import React, { Component } from 'react';

import { BundleJson, InstructionType } from '../../types/bundleTypes';

import './MonitorBundleInfo.scss';
import { OrderClazz } from '../../types/orderTypes';
import { getBundleColor } from '../oldPlanner/utils/bundleDraft';
import dayjs from 'dayjs';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import {
  findLastCompletedInstruction,
  findNextInstruction,
} from '../bundles/components/BundleUtils';

interface Props {
  orders: OrderClazz[];
  bundle: BundleJson;
  selected: boolean;
  onShowClick: () => void;
}

export default class MonitorBundleInfo extends Component<Props> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  lastDeliveryDiff(): number {
    const lastDeliveredInstruction = findLastCompletedInstruction(
      this.props.bundle,
      InstructionType.Delivery
    );
    const lastDeliveredOrderId =
      lastDeliveredInstruction && lastDeliveredInstruction.orderId;
    const lastDeliveredOrder = this.props.orders.find(
      order => order.id === lastDeliveredOrderId
    );

    const lastDelivery =
      lastDeliveredOrder && lastDeliveredOrder.deliveredAt
        ? dayjs(lastDeliveredOrder.deliveredAt)
        : null;

    if (lastDelivery) {
      if (lastDeliveredInstruction?.eta?.isValid()) {
        return lastDelivery.diff(lastDeliveredInstruction.eta, 'minute');
      }
    }
    return 0;
  }

  lastDeliveryTime(): string {
    const lastDeliveredInstruction = findLastCompletedInstruction(
      this.props.bundle,
      InstructionType.Delivery
    );
    const lastDeliveredOrderId =
      lastDeliveredInstruction && lastDeliveredInstruction.orderId;
    const lastDeliveredOrder = this.props.orders.find(
      order => order.id === lastDeliveredOrderId
    );

    const lastDelivery =
      lastDeliveredOrder && lastDeliveredOrder.deliveredAt
        ? dayjs(lastDeliveredOrder.deliveredAt)
        : null;

    if (lastDelivery) {
      const lastDeliveryTime = lastDelivery.format('HH:mm');
      const etaMinutesDiff = this.lastDeliveryDiff();

      if (etaMinutesDiff > 0) {
        return `${lastDeliveryTime} (+${etaMinutesDiff}m)`;
      } else if (etaMinutesDiff < 0) {
        return `${lastDeliveryTime} (-${Math.abs(etaMinutesDiff)}m)`;
      }

      return lastDeliveryTime;
    } else {
      return '';
    }
  }

  nextDeliveryEta(): string {
    const nextDeliveryInstruction = findNextInstruction(
      this.props.bundle,
      InstructionType.Delivery
    );
    const eta = nextDeliveryInstruction?.eta;
    return eta && eta.isValid() ? eta.format('HH:mm') : '';
  }

  nextDeliveryEtaIsLate(): boolean {
    const nextDeliveryInstruction = findNextInstruction(
      this.props.bundle,
      InstructionType.Delivery
    );
    const eta = nextDeliveryInstruction?.eta;
    return eta && eta.isValid() ? dayjs().diff(eta, 'minute') > 1 : false;
  }

  render() {
    const { bundle, onShowClick, selected } = this.props;
    const bundleInstructions = bundle.instructions;
    const ordersDelivered = bundleInstructions.filter(
      instr => instr.type === InstructionType.Delivery && instr.completed
    ).length;

    return (
      <tr className="monitor-bundle-info">
        <td
          style={{
            borderColor: getBundleColor(bundle.id),
          }}
        />
        <td>
          <Link
            to={`/bundles/${bundle.id}`}
            className="link__clean"
            target={'_blank'}
          >
            {bundle.id}
          </Link>
        </td>
        <td>{bundle.assignedCourierName || 'Courier not assigned'}</td>
        <td>
          {ordersDelivered} / {bundleInstructions.length / 2}
        </td>
        <td
          style={{
            color: this.lastDeliveryDiff() > 15 ? 'darkred' : undefined,
          }}
        >
          {this.lastDeliveryTime()}
        </td>
        <td
          style={{
            color: this.nextDeliveryEtaIsLate() ? 'darkred' : undefined,
          }}
        >
          {this.nextDeliveryEta()}
        </td>
        <td className="monitor-bundle-info--show" onClick={() => onShowClick()}>
          {selected && <FaEye />}
          {!selected && <FaEyeSlash />}
        </td>
      </tr>
    );
  }
}
